import { useState, type InputHTMLAttributes } from 'react'

/**
 * ПОЛЕ ПАРОЛЯ С ГЛАЗОМ
 *
 * Пароль набирают на телефоне одной рукой, вслепую, под звёздочками —
 * и одна лишняя буква превращается в «неверный пароль» без объяснений.
 * А при регистрации ещё хуже: опечатка уезжает в базу, и человек потом
 * не может войти паролем, который «точно набирал правильно».
 *
 * Глаз показывает набранное. Нажал ещё раз — снова звёздочки. После
 * отправки формы поле само прячет пароль: оставлять его открытым на
 * экране незачем.
 */
export function PasswordInput(props: Omit<InputHTMLAttributes<HTMLInputElement>, 'type'>) {
  const [shown, setShown] = useState(false)

  return (
    <span className="password-field">
      <input {...props} type={shown ? 'text' : 'password'} />
      <button
        type="button"
        className="password-eye"
        onClick={() => setShown((v) => !v)}
        // Нажатие не должно уводить ввод из поля: иначе на телефоне
        // прячется клавиатура и курсор теряет место
        onMouseDown={(event) => event.preventDefault()}
        aria-label={shown ? 'Скрыть пароль' : 'Показать пароль'}
        aria-pressed={shown}
        title={shown ? 'Скрыть пароль' : 'Показать пароль'}
      >
        <svg
          viewBox="0 0 24 24"
          width="20"
          height="20"
          fill="none"
          stroke="currentColor"
          strokeWidth="1.75"
          strokeLinecap="round"
          strokeLinejoin="round"
          aria-hidden="true"
        >
          <path d="M2 12s3.6-7 10-7 10 7 10 7-3.6 7-10 7S2 12 2 12z" />
          <circle cx="12" cy="12" r="3" />
          {/* Перечёркнутый — когда пароль виден: нажми, чтобы спрятать */}
          {shown && <path d="M4 4l16 16" />}
        </svg>
      </button>
    </span>
  )
}
